export default __webpack_public_path__ + "static/media/2.22eed4c5.png";